/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Notification_TemplatesInputs */

const en_nav_notification_templates = /** @type {(inputs: Nav_Notification_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email templates`)
};

/**
* | output |
* | --- |
* | "Email templates" |
*
* @param {Nav_Notification_TemplatesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_notification_templates = /** @type {((inputs?: Nav_Notification_TemplatesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Notification_TemplatesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_notification_templates(inputs)
});